import { auth, Tokens } from "marvin-auth-kit";
import { useMutation, UseMutationOptions } from "react-query";
import { APIError } from "src/types";

type LoginMutationOptions = UseMutationOptions<
  Tokens | undefined,
  APIError[] | Error,
  { email: string; password: string },
  unknown
>;
export function useLoginMutation(options?: LoginMutationOptions) {
  async function mutationFn(email: string, password: string) {
    const response = await auth.login(email, password);
    return response;
  }

  return useMutation((values) => mutationFn(values.email, values.password), options);
}
